<nz-spin class="component-files-container"
         [nzSize]="'large'"
         [nzSpinning]="!componentFilesMenu.items?.length">
  <p *ngIf="!componentFilesMenu.items?.length && !selectedFileName"
     class="loading-message">
    <i class="fa-solid fa-circle-notch fa-spin fa-lg"></i> &nbsp;
    Loading component files...
  </p>
  <div *ngIf="componentFilesMenu.items?.length && selectedFileName"
       class="wrapper">
    <div class="menu-area">
      <nz-collapse>
        <nz-collapse-panel class="component-files-collapse-panel"
                           nzHeader="Component Files"
                           nzActive="true">
          <rappider-menu [config]="componentFilesMenu"
                         (menuItemClick)="fileNameOnMenuClicked($event)"></rappider-menu>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
    <div class="code-area">

      <div class="code-editor-container">
        <div class="code-editor-container-inner">
          <rappider-monaco-code-editor #editorRef
                                       [options]="componentCodeEditorOptions"
                                       [borderSettings]="{border: 'none'}"
                                       [(ngModel)]="componentDefinitionFileContents[selectedFileName ?? 'unknown']"></rappider-monaco-code-editor>
        </div>
        <div class="code-editor-container-footer">
          <!-- Add a save button -->
          <button nz-button
                  [nzLoading]="isSaving"
                  [nzSize]="'medium'"
                  nzType="primary"
                  (click)="saveComponentDefinitionFileContents()">
            <i class="fa-solid fa-floppy-disk white"></i> &nbsp; Save Code Changes
          </button>

        </div>
      </div>



    </div>
  </div>

</nz-spin>
